export var DEFAULT = 'default';
export var IMAGE = 'Raster';
export var TEXT = 'Text';
export var SHAPE = 'Shape';
export var GROUP = 'Group';
export var MASK = 'Mask';
